// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 391 ? "ms-teams-auth-adapter" : chunkId) + "." + {"20":"6f4453bd","43":"70f95c23","316":"16dbdf39","372":"c14a39e2","391":"eda8ce0a","695":"1595e939","817":"e57e9c22"}[chunkId] + ".js";
};